module.exports = __webpack_public_path__ + "img/Milenia.0981421a.png";